import * as React from "react";
import {Box} from "../box/box.component";
import {StyledMyProducts} from "./myProducts.style";
import {GeneralContext} from "../../core/general.context";
import {UserContext} from "../../core/user.context";
import {
    PROJECT_LANGUAGE,
    BRX_PRODUCTS_URL,
    calls,
    BRX_BASE_URL,
    BRX_DOWNLOAD_MANUAL_REL_PATH
} from "../../core/APIUtils";
import {LabelContext} from "../../core/label.context";
import {RESTContext} from "../../core/rest.context";

type DistinctProduct = {
    sku: string;
    image: string;
    name: string;
    description?: string;
};

export const MyProducts = (props: any) => {
    const {orders} = React.useContext(GeneralContext);
    const {getDistinctProductsFromOrders} = React.useContext(UserContext);
    const {t} = React.useContext(LabelContext);
    const {ajax$} = React.useContext(RESTContext);

    const [productPageAvailable, setProductPageAvailable] = React.useState<Record<string, boolean>>({});
    const [products, setProducts] = React.useState<DistinctProduct[] | null>(null);

    React.useEffect(() => {
        if (!orders?.results || orders?.results?.length === 0) {
            setProducts([]);
            return;
        }

        const excludedFamilies = ["services", "GIFTCARD", "EXTERNAL-PRODUCT"];
        const products = getDistinctProductsFromOrders(orders.results, PROJECT_LANGUAGE, excludedFamilies);
        setProducts(products);
    }, [orders]);

    React.useEffect(() => {
        if (!products || products.length === 0) {
            setProductPageAvailable({})
            return
        }

        const skus = products.map(p => p.sku)
        const where = `masterVariant(sku in (${skus.map(s => `"${s}"`).join(",")}))`

        const sub = ajax$(calls.Project.queryProductProjection(where))
            .subscribe((res: any) => {
                const foundSkus = new Set(
                    res?.results?.map((p: any) => p.masterVariant?.sku)
                )

                const availability: Record<string, boolean> = {}
                for (const sku of skus) {
                    availability[sku] = foundSkus.has(sku)
                }

                setProductPageAvailable(availability)
            })

        return () => sub.unsubscribe()
    }, [products])


    return (
        <StyledMyProducts>
            <Box className="unboxed secondary unbordered">
                <h2>{t("ecommerce.myaccount.my-products-title-section")}</h2>

                {products && products.length > 0 && (
                    products.map((p) => (
                        <div className="product mb-5 pb-5" key={p.sku}>
                            <a href={productPageAvailable[p.sku] ? `${BRX_PRODUCTS_URL}${p.sku}` : undefined}
                               onClick={(e) => {
                                   if (!productPageAvailable[p.sku]) {
                                       e.preventDefault();
                                       e.stopPropagation();
                                   }
                               }}
                            >
                                <div className="product-image">
                                    <img src={p.image} alt={p.name}/>
                                </div>
                            </a>

                            <div className="product-content">
                                <a href={productPageAvailable[p.sku] ? `${BRX_PRODUCTS_URL}${p.sku}` : undefined}
                                   onClick={(e) => {
                                       if (!productPageAvailable[p.sku]) {
                                           e.preventDefault();
                                           e.stopPropagation();
                                       }
                                   }}
                                >
                                    <span className="product-sku">{p.sku}</span>
                                    <h3>{p.name}</h3>
                                </a>

                                <a className="product-content-container"
                                   href={
                                       productPageAvailable[p.sku]
                                           ? `${BRX_PRODUCTS_URL}${p.sku}#${t("product.download")}`
                                           : (BRX_DOWNLOAD_MANUAL_REL_PATH !== ""
                                               ? `${BRX_BASE_URL}${BRX_DOWNLOAD_MANUAL_REL_PATH}?sku=${encodeURIComponent(p.sku)}`
                                               : undefined)
                                   }
                                   onClick={(e) => {
                                       if (!productPageAvailable[p.sku] && BRX_DOWNLOAD_MANUAL_REL_PATH === "") {
                                           e.preventDefault();
                                           e.stopPropagation();
                                       }
                                   }}
                                >
                                    {(productPageAvailable[p.sku] || BRX_DOWNLOAD_MANUAL_REL_PATH !== "") && (
                                        <div className="action-link font-weight-bold">
                                            {t("ecommerce.myaccount.my-products-manuals-cta")}
                                        </div>
                                    )}
                                </a>
                                {!productPageAvailable[p.sku] && (
                                    <div>
                                        {t("ecommerce.myaccount.my-products-removed-from-website")}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                )}

                {(!products || products.length === 0) && (
                    <div className="empty-state">
                        <p>{t("ecommerce.myaccount.my-products-empty-message")}</p>
                    </div>
                )}
            </Box>
        </StyledMyProducts>
    );
};


